(function () {
    'use strict';

    let ul = $('.logos');
    ul.each(function (index, element) {
        let items = $(element).children('.logo');

        if (items.length > 10) {
            setSixClass();

            setTimeout(function () {
                setInterval(setRandomClass, 4000); //number of milliseconds (2000 = 2 seconds)
            }, 4000);

            function setSixClass() {
                let number = items.length;
                let numberlist = [];
                while (numberlist.length < 10) {
                    let random = Math.floor(Math.random() * number);

                    if (!numberlist.includes(random)) {
                        numberlist.push(random);
                        items.eq(random).addClass('special');
                    }
                }
            }

            function setRandomClass() {
                let specialItems = $(element).children('.special');
                let allItems = $(element).children('div:not(.special)');
                let number = specialItems.length;
                let number2 = allItems.length;
                let random = Math.floor(Math.random() * number);
                let random2 = Math.floor(Math.random() * number2);
                specialItems.eq(random).removeClass('special');
                allItems.eq(random2).addClass('special');
            }
        } else {
            items.addClass('special');
        }
    });
})();
